"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownInput = void 0;
var react_1 = __importStar(require("react"));
var react_md_editor_1 = __importDefault(require("@uiw/react-md-editor"));
var rehype_sanitize_1 = __importDefault(require("rehype-sanitize"));
require("../../../index.css");
var MarkdownInput = /** @class */ (function (_super) {
    __extends(MarkdownInput, _super);
    function MarkdownInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { error: "" };
        _this.setAsyncState = function (newState) {
            return new Promise(function (resolve) { return _this.setState(newState, resolve); });
        };
        _this.handleOnChange = function (value) {
            var _a;
            _this.props.onChange((_a = _this.props.id) !== null && _a !== void 0 ? _a : "", value);
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var testCond, error, textFilter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        testCond = false;
                        error = "Please input markdown text";
                        if (!this.props.optional) {
                            textFilter = /^[^\s]+(\s+[^\s]+)*\s*\s?$/;
                            testCond = textFilter.test(this.props.value);
                            /* eslint-enable */
                        }
                        else {
                            testCond = true;
                        }
                        if (!!testCond) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setAsyncState({ error: error })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setAsyncState({ error: "" })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, testCond];
                }
            });
        }); };
        return _this;
    }
    MarkdownInput.prototype.render = function () {
        var defaultClassName = "";
        if (this.props.containerClassName)
            defaultClassName += this.props.containerClassName;
        if (this.props.disabled) {
            defaultClassName += "pointer-events-none opacity-60";
        }
        var excludedCommands = new RegExp(/^(?!.)/);
        if (this.props.excludeCommands) {
            excludedCommands = new RegExp("(".concat(this.props.excludeCommands.join("|"), ")"));
        }
        return (react_1.default.createElement("div", { className: defaultClassName },
            react_1.default.createElement("label", { className: "block text-sm font-medium text-gray-700" },
                this.props.label,
                " ",
                this.props.labelExtra),
            this.props.subLabel && (react_1.default.createElement("label", { className: "block text-xs font-medium text-gray-500 mb-2" }, this.props.subLabel)),
            react_1.default.createElement(react_md_editor_1.default, { id: this.props.id, className: "".concat(this.state.error.length > 0 && "w-md-editor-error", " mt-2"), value: this.props.value, onChange: this.handleOnChange, textareaProps: {
                    placeholder: this.props.placeholder,
                }, visibleDragbar: this.props.visibleDragbar, commandsFilter: function (cmd) { var _a; return cmd && excludedCommands.test((_a = cmd.name) !== null && _a !== void 0 ? _a : "") ? false : cmd; }, "data-color-mode": "light", highlightEnable: false, previewOptions: {
                    rehypePlugins: [[rehype_sanitize_1.default]],
                } }),
            this.state.error && (react_1.default.createElement("span", { className: "text-red-500 text-sm" }, this.state.error))));
    };
    return MarkdownInput;
}(react_1.Component));
exports.MarkdownInput = MarkdownInput;
//# sourceMappingURL=index.js.map